:root {
  /* We don't get these in vars, so manually add the header/footer height here */
  --record-link-modal-header-foot-height: calc(54px + 62px);
}
.modalWrapper {
  width: 800px;
  max-height: 800px;
  height: auto;
}

.modalBody {
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: calc(100% - var(--record-link-modal-header-foot-height) - var(--spacer-8) * 2);
  /* Gap for scrollbar */
  margin: 2px 2px 2px 0;
  padding: var(--spacer-8);
  gap: var(--spacer-5);
  /* Avoid scrollbar on firefox */
  overflow-x: hidden;
  overflow-y: scroll;
}

.modalBody::-webkit-scrollbar {
  width: 6px;
}
.modalBody::-webkit-scrollbar-track {
  background: transparent;
}
.modalBody::-webkit-scrollbar-thumb {
  background: var(--aha-gray-500);
  border-radius: 3px;
}
.modalBody::-webkit-scrollbar-thumb:hover {
  background: var(--aha-gray-600);
}

.modalLoading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dependencyWrapper {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.dependencyTitle {
  /* Oddly specific flex values here to keep the layout simjple while still getting
  the right spacing */
  flex: 0.23;
  font-size: var(--font-size-100);
  font-weight: 600;
  color: var(--theme-primary-text);
}

.recordSection {
 display: flex;
 margin-top: var(--spacer-6);
 font-size: var(--font-size-100);
 font-weight: 600;
 color: var(--theme-primary-text);
}

.recordTitle {
  flex: 0.3;
  font-size: var(--font-size-100);
  font-weight: 600;
  color: var(--theme-primary-text);
}

.recordWrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: var(--spacer-1);
}

.rowRecord {
  display: flex;
  flex: 1;
  font-size: var(--default-font-size);
  font-weight: 400;
  color: var(--theme-primary-text);
}

.rowRef {
  margin-right: 6px;
  color: var(--theme-tertiary-text);
}

.rowName {
  flex: 1;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.divider {
  width: 100%;
  margin: var(--spacer-1) 0;
  border: 1px solid var(--theme-primary-border);
}

/* Single item styling */
.row {
  display: flex;
  gap: 64px;
}

.rowHeader {
  font-size: var(--font-size-100);
  font-weight: 600;
  color: var(--theme-primary-text);
}
